import React from "react";
import { IUserApiClient, UserDto } from "../clients/userApiClient";
import { useInjection } from "../di/ioc-provider"
import { TYPES } from "../di/types"
import { AuthStore } from "../stores/AuthStore";
import { SortOrder } from "../clients/dossierApiClient";
import { FormControl, InputLabel, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import { List } from "linqts";

export interface UserPickerProps {
onUserSelected : (user : number) => void;
}

export const UserPicker = (props : UserPickerProps) => {


    const _userService = useInjection<IUserApiClient>(TYPES.IUserClient);
    const authObj = AuthStore.useState(w => w.authSettings);
    const [t] = useTranslation("common");
    const [users,setUsers] = React.useState<UserDto[]>([]);


    React.useEffect(() => {
        if (authObj.role) {
            fetchUsers();
        }

    }, [authObj.role])

    if(!authObj?.role){
        return <></>
    }


    const fetchUsers = () => {
        _userService.getUsers({skip : 0,take : 1000,sortColumn : "Created",sortOrder : SortOrder.DESC,payload:{search : ""}})
        .then((res) => {
            setUsers(new List(res.data.data).OrderBy(w=>w.firstName).ToArray());
        })
    }
    const handleSelect = (e: any) => {
       props.onUserSelected(e.target.value);
    }
    return <>
        <FormControl variant="outlined" style={{width:"100%"}}>
            <InputLabel htmlFor="userPicker">{t("general.userPickerLabel")}</InputLabel>
            <Select
                style={{ marginTop: "16px" }}
                native
                label={t("general.userPickerLabel") }
                onChange={handleSelect}
                id="countryPicker"
            >
                <option value={null}>Geen geselecteerd</option>
                {users.map((el) => {
                    return <option value={el.id}>{el.firstName} {el.lastName} - {el.email}</option >
                })}
            </Select>
        </FormControl>
    </>
}